import styled from 'styled-components'

export const FooterMessage = styled.h5`
  font: var(--theme-typography-h5-semiBold);
  color: var(--theme-colors-global-grey-grey700);
  margin-right: auto;
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  height: 100%;
  width: 100%;
`
